import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from '../_shared/shared.service';
import { TravelAgentProfile } from './travel-agent-profile';

@Injectable({ providedIn: 'root' })
export class TravelAgentProfileService {

	portalAcceses: any = [
		{ value: 0, name: 'Disabled' },
		{ value: 1, name: 'Active' },
		{ value: 2, name: 'Invited' }
	];

	addressTypes: any = [
		{ value: 1, name: 'home' },
		{ value: 2, name: 'work' }
	];

	titles = [
		{ name: 'Mr.', value: 'Mr.' },
		{ name: 'Mrs.', value: 'Mrs.' },
		{ name: 'Ms.', value: 'Ms.' },
		{ name: 'Dr.', value: 'Dr.' },
	];

	percentages = [
		{ value: 0.00, name: '0%' },
		{ value: 0.01, name: '1%' },
		{ value: 0.02, name: '2%' },
		{ value: 0.03, name: '3%' },
		{ value: 0.04, name: '4%' },
		{ value: 0.05, name: '5%' },
		{ value: 0.06, name: '6%' },
		{ value: 0.07, name: '7%' },
		{ value: 0.08, name: '8%' },
		{ value: 0.09, name: '9%' },
		{ value: 0.10, name: '10%' },
		{ value: 0.11, name: '11%' },
		{ value: 0.12, name: '12%' },
		{ value: 0.13, name: '13%' },
		{ value: 0.14, name: '14%' },
		{ value: 0.15, name: '15%' },
		{ value: 0.16, name: '16%' },
		{ value: 0.17, name: '17%' },
		{ value: 0.18, name: '18%' },
		{ value: 0.19, name: '19%' },
		{ value: 0.20, name: '20%' },
		{ value: 0.21, name: '21%' },
		{ value: 0.22, name: '22%' },
		{ value: 0.23, name: '23%' },
		{ value: 0.24, name: '24%' },
		{ value: 0.25, name: '25%' },
		{ value: 0.26, name: '26%' },
		{ value: 0.27, name: '27%' },
		{ value: 0.28, name: '28%' },
		{ value: 0.29, name: '29%' },
		{ value: 0.30, name: '30%' },
		{ value: 0.31, name: '31%' },
		{ value: 0.32, name: '32%' },
		{ value: 0.33, name: '33%' },
		{ value: 0.34, name: '34%' },
		{ value: 0.35, name: '35%' },
		{ value: 0.36, name: '36%' },
		{ value: 0.37, name: '37%' },
		{ value: 0.38, name: '38%' },
		{ value: 0.39, name: '39%' },
		{ value: 0.40, name: '40%' },
		{ value: 0.41, name: '41%' },
		{ value: 0.42, name: '42%' },
		{ value: 0.43, name: '43%' },
		{ value: 0.44, name: '44%' },
		{ value: 0.45, name: '45%' },
		{ value: 0.46, name: '46%' },
		{ value: 0.47, name: '47%' },
		{ value: 0.48, name: '48%' },
		{ value: 0.49, name: '49%' },
		{ value: 0.50, name: '50%' },
		
	];

	affiliationTypes = [
		{ value: 1, name: 'Consortium' },
		{ value: 2, name: 'Affiliation' },
		{ value: 3, name: 'Independent' }
	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'travel-agent-profiles';

	add(travelAgentProfile: TravelAgentProfile): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(travelAgentProfile));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, travelAgentProfile);
	}

	update(travelAgentProfile: TravelAgentProfile): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, travelAgentProfile);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	activatePortalAccess(id: number): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/activate-portal-access`, {});
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	markCommissionPaid(reservationId: number, payDate: string): Observable<any> {
		return this.http.patch<any>(`${environment.apiUrl}/reservations/${reservationId}/commission-paid`,
			{ commissionPayDate: payDate, commissionPayStatus: 'PAID' });
	}

	getAgentReservations(travelAgentProfileId: number): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/travel-agent-profiles/${travelAgentProfileId}/reservations`);
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
